export const FEATURE_NAME = '@zerops/zerops/feature/project-env-edit-dialog';
